import { useState, useEffect, memo, useRef } from 'react';
import { Row, Col } from 'antd';
import * as React from 'react';
import ProtectedLeadInformation from './ProtectedLeadInformation';
import dayjs from 'dayjs';
import { settaskStartTime } from '../../../Slices/user';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import AgencyInformationForm from './AgencyInformationForm';
import SalesWorkHistory from './SalesWorkHistory';
import EmailSequencePanel from './EmailSequencePanel';
import ContactInformationForm from './ContactInformationForm';
import AttachemntsHistory from './AttachmentHistory';
import CommentField from './CommentField';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Starttask } from '../../../Slices/timerslice';
import { updateWorkHistoryThunk } from "../../../Slices/orderSlice";
import { Typography, } from 'antd';
import { timerHistoryPayloadChange } from '../../../Slices/user';
import { getAllLeadWorkHistory } from '../../../Slices/salesSlice';


const SaleInformation2 = memo((props) => {
    dayjs.extend(timezone);
    dayjs.extend(utc);
    const { SalesInfo, salesLeadId, assignToUsers, id, callingTrackRef } = props;
    const task = useSelector((state) => state.timer.task);
    const dispatch = useDispatch();
    const CurrentTask = "Data Processing";
    const { values, handleChange, handleBlur, errors, touched, setFieldValue } = useFormikContext();
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const userId = loginUser?.id;
    const [isRunning, setIsRunning] = useState(false);
    const [close, setClose] = useState(!values?.lastContactedDate ? true : false);


    const isInitialized = useRef(false);
    const { showSidePanel } = props;


    useEffect(() => {
        setClose(values?.lastContactedDate ? false : true);
    }, [values?.lastContactedDate]);


    useEffect(() => {
        if (!values.followup) {
            setFieldValue('followupDate', null);
        }
    }, [values.followup]);

    useEffect(() => {
        if (!isInitialized.current && values.lastContactedDate) {
            isInitialized.current = true;
        }
    }, []);

    function formatDateTime(timestamp) {
        const date = new Date(parseInt(timestamp));
        const formattedDate = date.toLocaleString('en-IN', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });

        let datee = formattedDate.replace(/\b(am|pm)\b/, match => match.toUpperCase());
        let finalDate = null;
        if (datee === "Invalid Date") {
            finalDate = "-"
        } else {
            finalDate = datee
        }

        return finalDate;
    }

    const assignHandler = (checked) => {
        setFieldValue('assign', checked);

        if (checked) {
            setFieldValue('assignedTo', loginUser?.firstname + " " + loginUser?.lastname);
            setFieldValue('assignTo', loginUser?.firstname + " " + loginUser?.lastname);
        } else {
            setFieldValue('assignedTo', '');
            setFieldValue('assignTo', '');
        }
    }

    const getAssignToUsers = (usersList) => {
        const usersListFormatted = [];
        for (let i = 0; i < usersList?.length; i++) {
            usersListFormatted.push({
                key: i,
                value: usersList[i].firstname + " " + usersList[i].lastname,
            });
        }
        return usersListFormatted;
    }

    const handleStartButtonClick = async () => {
        const payload = {
            department: "Sales",
            task: "Data Processing",
            time: Date.now(),
            requestId: SalesInfo.leadID,
        };

        try {
            const valuesObject = {
                userId: userId,
                emailId: SalesInfo?.id,
                requestId: SalesInfo?.leadID?.toString(),
                clientName: "Blueplanit",
                processType: "",
                taskType: "Data Processing",
                email: "",
                subject: "",
                body: "",
                startTime: Date.now().toString(),
                endTime: "",
                department: 'Sales'
            }
            await dispatch(updateWorkHistoryThunk(valuesObject)).unwrap();
        } catch (err) {
            console.error("Error updating work history:", err);
        }
        localStorage.setItem("task", "Data Processing");
        localStorage.setItem("department", "Sales");
        localStorage.setItem("time", Date.now());
        localStorage.setItem("requestId", SalesInfo?.leadID || salesLeadId);
        dispatch(Starttask(payload));
    };

    const handleStop = async () => {
        setIsRunning(false);

        const valuesObject = {
            id: Math.random().toString(),
            userId: userId,
            title: "",
            description: "",
            clientName: "Blueplanit",
            department: loginUser.department,
            taskType: "Available",
            startTime: Date.now().toString(),
            endTime: Date.now().toString(),
            requestId: "",
        };
        dispatch(timerHistoryPayloadChange({ data: valuesObject }));
        const values = {
            userId: userId,
            emailId: "",
            requestId: "",
            clientName: "Blueplanit",
            processType: "",
            taskType: "Available",
            email: "",
            subject: "",
            body: "",
            startTime: Date.now().toString(),
            endTime: "",
            department: loginUser.department
        }
        await dispatch(updateWorkHistoryThunk(values)).unwrap();
        const payload = {
            department: "",
            requestId: "",
            task: "Available",
            time: Date.now(),
        };
        localStorage.setItem("time", new Date().getTime());
        localStorage.removeItem("department");
        localStorage.removeItem("requestId");
        localStorage.removeItem("task");
        dispatch(settaskStartTime(new Date().getTime()));
        dispatch(Starttask(payload));
        dispatch(getAllLeadWorkHistory(SalesInfo?.id));
    };

    const handleAddRow = (arrayHelpers) => {
        arrayHelpers.push({
            contactPerson: '',
            title: '',
            phone: '',
            email: '',
            remarks: '',
            status: false,
        });
    };

    const getDateTimeValue = (datevalue) => {
        let finalDate = null;
        if (datevalue !== undefined || datevalue !== '') {
            if (typeof datevalue === 'string' && datevalue?.length === 13) {
                finalDate = dayjs(parseInt(datevalue))
            } else if (typeof datevalue === 'object') {
                finalDate = datevalue
            }
        }
        return finalDate;
    }

    return (
        <>
            <Row gutter={8} style={{ flexDirection: showSidePanel ? "column" : "row" }}>

                {/* LEFT SIDE → Protected Lead Information */}
                <Col span={showSidePanel ? 12 : 12}>
                    <ProtectedLeadInformation
                        SalesInfo={SalesInfo}
                        values={values}
                        setFieldValue={setFieldValue}
                        assignToUsers={assignToUsers}
                        loginUser={loginUser}
                        formatDateTime={formatDateTime}
                        assignHandler={assignHandler}
                        getAssignToUsers={getAssignToUsers}
                        getDateTimeValue={getDateTimeValue}
                    />
                </Col>

                {/* RIGHT SIDE → Agency Information */}
                <Col span={showSidePanel ? 12 : 12} style={{ marginTop: showSidePanel ? "15px" : "0px" }}>
                    <AgencyInformationForm
                        values={values}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleStartButtonClick={handleStartButtonClick}
                        handleStop={handleStop}
                        isRunning={isRunning}
                        task={task}
                        CurrentTask={CurrentTask}
                        id={id}
                        leadID={SalesInfo?.leadID}
                    />
                </Col>

            </Row>


            {/* CARD 2: CONTACT INFORMATION*/}
            <Row gutter={16}>
                <Col span={showSidePanel ? 12 : 24}>   {/* 👈 CARD width reduces here */}
                    <div
                        style={{
                            marginTop: "15px",
                            backgroundColor: "#fff",
                            padding: "10px 10px 0px 10px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                        }}
                    >
                        <Typography.Title level={5}>Contact Information</Typography.Title>

                        <ContactInformationForm
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            callingTrackRef={callingTrackRef}
                            handleAddRow={handleAddRow}
                            showSidePanel={showSidePanel}
                        />

                        <CommentField label="Comments" name="contactInfoComments" />
                    </div>
                </Col>
            </Row>


            {/* EMAIL SEQUENCE PANEL */}
            {SalesInfo?.id && (
                <Row gutter={16}>
                    <Col span={showSidePanel ? 12 : 24}>
                        <EmailSequencePanel
                            leadId={SalesInfo?.id}
                            leadName={SalesInfo?.agencyName || values?.agencyName}
                            contacts={values?.leadsContacts}
                            repName={loginUser ? `${loginUser.firstname} ${loginUser.lastname}` : ""}
                            repEmail={loginUser?.email}
                        />
                    </Col>
                </Row>
            )}

            {/* CARD 3: ATTACHMENT HISTORY + SALES WORK HISTORY */}
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: showSidePanel ? "column" : "row",   // 🔥 switch layout
                    justifyContent: "space-between",
                    marginTop: "15px",
                    gap: "16px",
                }}
            >

                {/* LEFT SIDE → ATTACHMENT HISTORY */}
                {id && (
                    <div
                        style={{
                            width: showSidePanel ? "50%" : "100%",
                            backgroundColor: "#fff",
                            padding: "10px 20px 0px 10px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                        }}
                    >
                        <Typography.Title level={5}>Attachment History</Typography.Title>

                        <AttachemntsHistory
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            callingTrackRef={callingTrackRef}
                            handleAddRow={handleAddRow}
                            id={id}
                        />
                    </div>
                )}

                {/* RIGHT SIDE → SALES WORK HISTORY */}
                {SalesInfo?.id && (
                    <div
                        style={{
                            width: showSidePanel ? "50%" : "100%",
                            backgroundColor: "#fff",
                            padding: "10px 20px 0px 20px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                        }}
                    >
                        <Typography.Title level={5}>Sales Work History</Typography.Title>

                        <SalesWorkHistory
                            SalesInfo={SalesInfo}
                            assignToUsers={assignToUsers}
                        />
                    </div>
                )}

            </div>

        </>
    );
});

export default SaleInformation2;